
const variables = {
    SystemTitle: "Erhvervsgavesystemet",
    AppBottomInfo: "ERHVERVS GAVER",
    ContactMail: "erhvervsgaver.dk",
    RedeemImage: "https://erhvervsgaver.dk/wp-content/uploads/2022/03/logo.png"
};

export default variables;
